import { Box, BoxProps, Center, Container, Flex, Heading } from '@chakra-ui/react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import CmsButton from '../../../../cms/components/Button/CmsButton';
import { secondaryTextColor } from '../../../../cms/utils/base';
import { isLinkDefined } from '../../../../cms/utils/sanity';
import { Icon } from '../../Icon/Icon';
import Markdown from '../../Markdown/Markdown';

const Cta = ({
  variant,
  heading,
  content,
  button,
  link,
  link2,
  footnote,
  ...rest
}: CMS.CTA & BoxProps): React.ReactElement | null => {
  const isHorizontal = variant === 1;
  const hasButton = isLinkDefined(button);
  const hasLink = isLinkDefined(link);
  const hasLink2 = isLinkDefined(link2);

  const contentUi = (
    <>
      <Heading as="h4" flexGrow={1} size={isHorizontal ? '3xl' : '4xl'}>
        {heading}
      </Heading>
      {content && !isHorizontal ? (
        <Markdown fontSize={['lg', 'xl', 'xl', '2xl']}>{content}</Markdown>
      ) : null}
      {hasButton && (
        <CmsButton
          data={button}
          isButton
          layoutBg={rest.bgColor}
          size={['def', 'md', 'lg', 'xl']}
          minW={['220px', '260px']}
          pl={{ base: 4, md: 8, xl: 12 }}
          pr={{ base: 4, md: 8, xl: 12 }}
          boxShadow="none"
        >
          {button.text}
        </CmsButton>
      )}
      {hasLink || hasLink2 ? (
        <Flex direction="row" columnGap={[8, 8, 10]} justify="center" align="center" wrap="wrap">
          {hasLink && !isHorizontal ? (
            <CmsButton
              data={link}
              layoutBg={rest.bgColor}
              size={['sm', 'def', 'md']}
              rightIcon={<Icon icon={faArrowRight} ml="px" />}
            >
              {link.text}
            </CmsButton>
          ) : null}
          {hasLink2 && !isHorizontal ? (
            <CmsButton
              data={link2}
              layoutBg={rest.bgColor}
              size={['sm', 'def', 'md']}
              rightIcon={<Icon icon={faArrowRight} ml="px" />}
            >
              {link2.text}
            </CmsButton>
          ) : null}
        </Flex>
      ) : null}
      {footnote && (
        <Markdown textAlign="center" color={secondaryTextColor(rest.bgColor)}>
          {footnote}
        </Markdown>
      )}
    </>
  );
  return (
    <Box {...rest} pt={isHorizontal ? 12 : rest.pt} pb={isHorizontal ? 12 : rest.pb}>
      <Container maxW={isHorizontal ? 'container.2xl' : 'container.xl'}>
        {isHorizontal ? (
          <Flex
            gap={[6, 8]}
            direction={{ base: 'column', lg: 'row' }}
            justify="middle"
            textAlign={{ base: 'center', lg: 'left' }}
            align="center"
          >
            {contentUi}
          </Flex>
        ) : (
          <Center flexDirection="column" textAlign={isHorizontal ? 'left' : 'center'} rowGap={6}>
            {contentUi}
          </Center>
        )}
      </Container>
    </Box>
  );
};
export default Cta;
